import './Loadings.css'

const Loading = () => {
  return (
    <>
      <div className="h-screen flex justify-center">
        <div className="loadingio-spinner-spinner-w3kwwsv7i0k">
          <div className="ldio-ra13xgbwmkd">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Loading;
